import { ShipmentStatus } from "@/utils/enum";
import { getShipmentCount, getDealerDashboardMap } from "@/services/shipments";

const Model = {
  namespace: "dealerDashboard",
  state: {
    data: {
      quotes: {
        pendingQuotesCount: 0,
        completedQuotesCount: 0,
      },
      shipments: {
        pendingQuotesShipmentsCount: 0,
        completedQuotesShipmentsCount: 0,
        postedShipmentsCount: 0,
        assignedShipmentsCount: 0,
        deliveredShipmentsCount: 0,
      },
    },
  },
  effects: {
    *fetchPendingQuotesShipmentsCount({}, { call, put, select }) {
      const pendingQuotesShipmentsCount = yield call(getShipmentCount, {
        status: ShipmentStatus.Pending,
      });

      yield put({
        type: "updateShipmentsProperty",
        payload: {
          pendingQuotesShipmentsCount,
        },
      });
    },
    *fetchCompletedQuotesShipmentsCount({}, { call, put }) {
      const completedQuotesShipmentsCount = yield call(getShipmentCount, {
        status: ShipmentStatus.Completed,
      });

      yield put({
        type: "updateShipmentsProperty",
        payload: {
          completedQuotesShipmentsCount,
        },
      });
    },
    *fetchPostedShipmentsCount({}, { call, put }) {
      const postedShipmentsCount = yield call(getShipmentCount, {
        status: ShipmentStatus.Posted,
      });

      yield put({
        type: "updateShipmentsProperty",
        payload: {
          postedShipmentsCount,
        },
      });
    },
    *fetchAssignedShipmentsCount({}, { call, put }) {
      const assignedShipmentsCount = yield call(getShipmentCount, {
        status: ShipmentStatus.Assigned,
      });

      yield put({
        type: "updateShipmentsProperty",
        payload: {
          assignedShipmentsCount,
        },
      });
    },
    *fetchDeliveredShipmentsCount({}, { call, put }) {
      const deliveredShipmentsCount = yield call(getShipmentCount, {
        status: ShipmentStatus.Delivered,
      });

      yield put({
        type: "updateShipmentsProperty",
        payload: {
          deliveredShipmentsCount,
        },
      });
    },
    *fetchMap({}, { call, put }) {
      const shipments = yield call(getDealerDashboardMap);

      yield put({
        type: "updateShipmentsProperty",
        payload: {
          mapShipments: shipments,
        },
      });
    },
  },
  reducers: {
    updateShipmentsProperty(state, { payload }) {
      let newState = {
        ...state,
        data: {
          ...state.data,
          shipments: {
            ...state.data?.shipments,
            ...payload,
          },
        },
      };

      return newState;
    },
  },
};

export default Model;
